var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"coursework-viewer__slide"},[_c('pre',{ref:"textEl",staticClass:"coursework-viewer__text-container js-text-container"})])}
var staticRenderFns = []

export { render, staticRenderFns }